// extracted by mini-css-extract-plugin
export var badge = "badge-module--badge--afac3";
export var mediumBadge = "badge-module--mediumBadge--2560a";